import posthog from 'posthog-js'

// Only initialize PostHog in production
if (import.meta.env.MODE === 'production') {
  posthog.init(
    import.meta.env.VITE_POSTHOG_KEY,
    {
      api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com',
      // Enable debug mode in development
      loaded: (posthog) => {
        if (import.meta.env.DEV) posthog.debug()
      }
    }
  )
}

export default posthog 